
import Tag from "./Tag.vue";
import Vue from 'vue'
import { api } from '../services/api';
export default Vue.extend({
    components: {
        Tag
    },
    props: {
        tags: {
            required: true,
            type: Array as () => Array<string>
        }
    },
    data() {
        return {
            rawTag: "",
            suggestedTags: [] as string[],
        }
    },
    methods: {
        reset() {
            this.suggestedTags = [];
            this.rawTag = "";
        },
        addTag(tag: string) {
            this.$emit("add", tag.toLowerCase());
            this.reset();
        },
        removeTag(tag: string) {
            this.$emit("remove", tag.toLowerCase());
        }
    },
    created() {
        this.$emit("setup", this.reset);
    },
    watch: {
        async rawTag(val: string) {
            if (val.endsWith(" ")) {
                const normalized = val.replaceAll(" ", "").toLowerCase();
                if (normalized.length > 0) {
                    this.addTag(normalized);
                }
            } else {
                const cachedTags = await api.getTags();
                this.suggestedTags = [];
                if (val.length > 0 && cachedTags) {
                    const normalized = val.toLowerCase();
                    this.suggestedTags = [];
                    for (const entry of cachedTags.values()) {
                        if (entry.includes(normalized)) {
                            this.suggestedTags.push(entry);
                        }
                    }
                    this.suggestedTags.length = Math.min(
                        5,
                        this.suggestedTags.length
                    );
                }
            }
        },

    }
})
